import React, { useContext, useEffect, useState } from 'react'
import PaymentCollectionHeader from 'views/pages/manage/masters/studentFinancials/paymentCollection/PaymentCollectionHeader'
import ExamSearchForm from './ExamSearchForm'
import ExamReciptListing from './ExamReceiptListing'
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod'
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod'
import { getCourseIdByBuAndTerm, getDropdowns, getExamCodeByBuAndTerm, getTermDateByTermId, searchExamReceipt } from '../util'
import moment from 'moment'
import ALoader from 'views/pages/manage/common/a-loader'
import { RolePermissions } from 'appContext'
import { PermissionContext } from 'appContext'
import { pages } from 'views/pages/manage/common/constant'
import { PermisionDenied } from 'views/pages/manage/common/commonComponents'

// import { endpoint } from '../../../../../manage/'

const ExamReceiptLanding=()=>{
const [selectedFilter, setSelectedFilter] = useState('SINGLE');
const [globalFilter, setGlobalFilter] = useState()
const [loader, setLoader] = useState(false)
const [rows, setRows] = useState();
const [rowCount, setRowCount] = useState(0)
const [dropdownData,setDropdownData] = useState({
    courseId:[],
    term:[],
    bu:[]
})
  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(
    permissions,
    pages['studentExamCharges']['id']
  );
const searchHandler=async(req,page=0)=>{
setLoader(true)
const res= await searchExamReceipt(updateRequest({
    ...req,businessArea:req?.businessArea?.label?[{label:req?.businessArea?.label, value:req?.businessArea?.label}]:[], 
    termValue: req?.term?.label?[{label:req?.term?.label,value:req?.term?.label}]:[],
    examDateFrom: req?.examDateFrom && moment(req?.examDateFrom).format('YYYY-MM-DD'),
    examDateTo: req?.examDateTo && moment(req?.examDateTo).format('YYYY-MM-DD')
}),page)
setRowCount(res?.data?.totalRecords)
setRows(res?.data?.examOtherChargesList)
setLoader(false)
}

useEffect(()=>{
    getDropdownData()
},[])
const getDropdownData= async()=>{
    setLoader(true)
    const d = await getDropdowns()
    setDropdownData((prev)=>(
        {
            ...prev,
            bu: d[0],
            term: d[1],
        }
    ))
    setLoader(false)
}
useEffect(()=>{
const getCourseId=async()=>{
    const res= await getCourseIdByBuAndTerm([globalFilter?.businessArea?.value],[globalFilter?.term?.value])
    setDropdownData((prev)=>(
        {
            ...prev,
            courseId:res
        }
    ))
}
console.log(globalFilter,'globalFilter')
globalFilter?.businessArea?.value&&globalFilter?.term?.value&&getCourseId()
},[globalFilter?.businessArea,globalFilter?.term])
useEffect(()=>{
    const getExamCode =async()=>{
        const req={
            businessAreaList:[globalFilter?.businessArea?.value],
            termList: [globalFilter?.term?.value]
        }
        const res= await getExamCodeByBuAndTerm(req)
        setDropdownData((prev)=>(
            {
                ...prev,
                examCode:res
            }
        ))
    }
    globalFilter?.businessArea?.value&&globalFilter?.term?.value&&getExamCode()
    },[globalFilter?.businessArea,globalFilter?.term])
useEffect(()=>{
    const getTerm=async()=>{
        const res= await getTermDateByTermId(globalFilter?.term?.value)
        console.log('res',res)
        setDropdownData((prev)=>(
            {
                ...prev,
                termStartDate:res?.termStartDate,
                termEndDate:res?.termEndDate
            }
        ))
    }
    // globalFilter?.term && getTerm()
    },[globalFilter?.term])
    return(
        userPermissions ? (
        <div className="d-flex flex-column remove-container-top-space">
            <div className="p-3 student-filer-container-printId">
                <PaymentCollectionHeader text="Search students to apply exam charges"/>
                <ExamSearchForm
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                searchHandler={searchHandler}
                dropdownData={dropdownData}
                setDropdownData={setDropdownData}
                />
            </div>
            {loader&&<ALoader position='fixed'/>}
            <ExamReciptListing
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            rowData={rows}
            searchHandler={searchHandler}
            rowCount={rowCount}
            dropdownData={dropdownData}
            />
        </div>
    ):
    <PermisionDenied />
)
}
export default ExamReceiptLanding
